// Tiny dependency-free CSV export helper. Used for admin "download your data" exports
// (roster today; attendance/sign-out history once the school-readable signoutLog lands).

// Escape a single cell for RFC-4180 CSV: wrap in quotes if it contains a comma, quote,
// or newline, and double any embedded quotes.
const escapeCell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// rows: array of objects. columns: [{ header, value }] where value is either a key
// string or a (row) => cell function.
export function toCsv(rows, columns) {
  const cell = (row, col) =>
    typeof col.value === "function" ? col.value(row) : row[col.value];
  const head = columns.map((c) => escapeCell(c.header)).join(",");
  const body = rows.map((r) => columns.map((c) => escapeCell(cell(r, c))).join(",")).join("\r\n");
  return `${head}\r\n${body}`;
}

// Trigger a browser download of `csv` as `filename`. The BOM makes Excel read UTF-8
// (accented names etc.) correctly instead of mangling it.
export function downloadCsv(filename, csv) {
  const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// "clinton-elementary-school" ← "Clinton Elementary School" — safe filename fragment.
export function slugify(text) {
  return (text || "export")
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "export";
}
